import { useMemo } from 'react';
import { Box } from '@mui/material';
import { useFormik } from 'formik';

import { FProgressBar } from '../../../../../../components/base';
import { FormTextField, useFormReadOnly } from '../../../../../common';
import { useSaveTreatmentPlanV3PageField } from '../../../../hooks';
import { toAssessmentObservationsFieldPayload } from '../utils';
import { ASSESSMENT_OBSERVATIONS_FORM_SCHEMA } from '../validationSchema';

import type { AssessmentObservationsSectionProps } from './types';

export default function AssessmentObservationsSection({
  assessmentPage,
  disabled,
  isUpdating,
  onUpdate,
}: AssessmentObservationsSectionProps) {
  const readOnly = useFormReadOnly();
  const initialValues = useMemo(
    () => ({ observations: assessmentPage.observations ?? '' }),
    [assessmentPage],
  );
  const formik = useFormik({
    initialValues,
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: ASSESSMENT_OBSERVATIONS_FORM_SCHEMA,
    onSubmit: () => undefined,
  });
  const { saveField } = useSaveTreatmentPlanV3PageField({
    formik,
    initialValues,
    onUpdate,
    toPayload: toAssessmentObservationsFieldPayload,
    validationSchema: ASSESSMENT_OBSERVATIONS_FORM_SCHEMA,
  });

  return (
    <Box component="form" noValidate onSubmit={formik.handleSubmit}>
      {isUpdating ? <FProgressBar /> : null}
      <FormTextField
        disabled={disabled}
        formik={formik}
        label="Observations noted during assessment"
        minRows={3}
        multiline
        name="observations"
        onBlur={saveField}
        placeholder="Describe any other observations noted during the assessment"
        readOnly={readOnly}
        required
      />
    </Box>
  );
}
